import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Layout, Input, Button, Form, Card, Divider, Table, MenuProps, Dropdown } from "antd";
import { putBuyerService } from "./BuyersPageService";
import Loader from "../../components/Loader/Loader";
import "./BuyersPage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import { getBuyersService, postBuyerService } from "./BuyersPageService";
import { removeTokenFromCookies } from "../../utils/cookies";
import NewBuyerForm from "../../components/NewBuyerForm/NewBuyerForm";
import Cookies from "universal-cookie";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";

const { Search } = Input;
const { Content } = Layout;

export interface BuyersPageInterface {}

const BuyersPage = (props: BuyersPageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pgBuyers, setPGBuyers] = useState([]);
  const [bwBuyers, setBWBuyers] = useState([]);
  const [editBuyerData, setEditBuyerData] = useState(null) as any;
  const [showBuyerForm, setShowBuyerForm] = useState(false);
  const [pgSearchText, setPGSearchText] = useState("");
  const [bwSearchText, setBWSearchText] = useState("");
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const buyersColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Name",
      key: "name",
      align: "left" as const,
      width: "30%",
      render: (record: any) => record.name,
    },
    {
      title: "Company Name",
      key: "companyName",
      align: "left" as const,
      width: "20%",
      render: (record: any) => record.companyName,
    },
    {
      title: "IC Number",
      key: "identificationCardNumber",
      align: "center" as const,
      width: "20%",
      render: (record: any) =>
        record.identificationCardNumber ? formatIdentificationCardNumber(record.identificationCardNumber) : null,
    },
    {
      title: "Passport Number",
      key: "passportNumber",
      align: "center" as const,
      width: "20%",
      render: (record: any) => (record.passportNumber ? record.passportNumber : null),
    },
    // {
    //   title: "Phone Number",
    //   key: "buyer",
    //   width: "20%",
    //   align: "center" as const,
    //   render: (record: any) => record.contactNumber,
    // },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        items.push({ key: "edit", label: "Edit Buyer", icon: <EditOutlined /> });
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") openEditBuyerView(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getBuyers();
  }, []);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const formatIdentificationCardNumber = (identificationCardNumber: string) => {
    return `${identificationCardNumber.slice(0, 6)}-${identificationCardNumber.slice(
      6,
      8
    )}-${identificationCardNumber.slice(8, 12)}`;
  };

  const getBuyers = async () => {
    try {
      setLoading(true);
      const res = await getBuyersService();
      setPGBuyers(res.data.pgBuyers);
      setBWBuyers(res.data.bwBuyers);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postBuyer = async (buyerInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        name: buyerInfo.name,
        companyName: buyerInfo.companyName,
        identificationCardNumber: buyerInfo.identificationCardNumber.replaceAll(" ", "").replaceAll("-", ""),
        contactNumber: "",
        email: "",
        address: "",
        companyCode: "",
        outstandingAmount: 0.0,
        passportNumber: buyerInfo.passportNumber,
        pgOffice: buyerInfo.pgOffice,
        bwOffice: buyerInfo.bwOffice,
      };
      const res = await postBuyerService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getBuyers();
      }, 2000);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const putBuyer = async (buyerInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        buyerID: buyerInfo.buyerID,
        name: buyerInfo.name,
        companyName: buyerInfo.companyName,
        identificationCardNumber: buyerInfo.identificationCardNumber.replaceAll(" ", "").replaceAll("-", ""),
        contactNumber: buyerInfo.contactNumber,
        email: buyerInfo.emailAddress,
        address: buyerInfo.address,
        companyCode: buyerInfo.companyCode,
        passportNumber: buyerInfo.passportNumber,
        pgOffice: buyerInfo.pgOffice,
        bwOffice: buyerInfo.bwOffice,
      };
      const res = await putBuyerService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getBuyers();
      }, 2000);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const openEditBuyerView = (record: any) => {
    setEditBuyerData(record);
    openBuyerForm();
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const openBuyerForm = () => {
    setShowBuyerForm(true);
  };

  const closeBuyerForm = () => {
    setShowBuyerForm(false);
  };

  const searchBuyersPG = async (searchText: string) => {
    if (searchText === "") {
      await getBuyers();
    } else {
      const currPGBuyers = [...pgBuyers];
      const text = searchText.toLocaleLowerCase();
      const searchBuyers = currPGBuyers.filter((buyer: any) => {
        if (buyer.name !== "" && buyer.name !== undefined && buyer.name.toLocaleLowerCase().search(text) !== -1) {
          return buyer;
        }
        if (
          buyer.companyName !== "" &&
          buyer.companyName !== undefined &&
          buyer.companyName.toLocaleLowerCase().search(text) !== -1
        ) {
          return buyer;
        }
      });
      setPGBuyers(searchBuyers);
    }
  };

  const searchBuyersBW = async (searchText: string) => {
    if (searchText === "") {
      await getBuyers();
    } else {
      const currBWBuyers = [...bwBuyers];
      const text = searchText.toLocaleLowerCase();
      const searchBuyers = currBWBuyers.filter((buyer: any) => {
        if (buyer.name !== "" && buyer.name !== undefined && buyer.name.toLocaleLowerCase().search(text) !== -1) {
          return buyer;
        }
        if (
          buyer.companyName !== "" &&
          buyer.companyName !== undefined &&
          buyer.companyName.toLocaleLowerCase().search(text) !== -1
        ) {
          return buyer;
        }
      });
      setBWBuyers(searchBuyers);
    }
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row justify="start">
                  <h2 className="buyers-title">Buyers</h2>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end" style={{ marginTop: "20px" }}>
                  <Button type="primary" onClick={() => openBuyerForm()}>
                    Add New Buyer
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row justify="start">
              <h2 className="office-buyers-title">Butterworth List</h2>
            </Row>
            <Row>
              <Search
                placeholder="Name / Company Name"
                allowClear
                enterButton="Search"
                onChange={(e: any) => searchBuyersBW(e.target.value)}
                style={{ marginBottom: "20px" }}
              />
            </Row>
            <Table dataSource={[...bwBuyers]} columns={buyersColumns} />
            <Row justify="start">
              <h2 className="office-buyers-title">Penang List</h2>
            </Row>
            <Row>
              <Search
                placeholder="Name / Company Name"
                allowClear
                enterButton="Search"
                onChange={(e: any) => searchBuyersPG(e.target.value)}
                style={{ marginBottom: "20px" }}
              />
            </Row>
            <Table dataSource={[...pgBuyers]} columns={buyersColumns} />
          </Col>
        </Row>
        <NewBuyerForm
          showForm={showBuyerForm}
          closeForm={closeBuyerForm}
          editBuyerData={editBuyerData}
          postBuyer={postBuyer}
          putBuyer={putBuyer}
        />
        <Copyright />
      </Content>
    </Layout>
  );
};

export default BuyersPage;
